import { getImage } from "../../services/ImageService";

export function PilotButton(props) {
    return (
        <a
            className={`h-24 max-w-72 select-none flex ${
                props.className ? props.className : ""
            }`}
            href="/pilot"
            target=""
            rel="noreferrer"
            draggable={false}
        >
            <img
                className="h-full pointer-events-none"
                src={getImage("buttons/download-gf-pilot.svg")}
                alt="Download GF Pilot"
                draggable={false}
            />
        </a>
    );
}
